import { forwardRef } from "react";
import Control, { ControlProps, ControlRef } from "@ebsco-ui/control";
import cn from "classnames";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";

import "./radio-button.scss";

export type RadioButtonProps = Omit<ControlProps, "icon" | "type">;

const RadioButton = forwardRef<ControlRef, RadioButtonProps>(
  ({ className, ...rest }: RadioButtonProps, forwardedRef) => (
    <Control
      ref={forwardedRef}
      icon={faCircle}
      type="radio"
      className={cn("eb-radio", className)}
      {...rest}
    />
  ),
);

RadioButton.displayName = "RadioButton";

export default RadioButton;
